import { DeviceSearchRequest } from './DeviceSearchRequest';

export const defaultForContentItemSearchRequest = () => {
    return DeviceSearchRequest.fromJS({
        searchText: '',
        includeDisabled: false,
        isUnassignedAccounts: false,
        isUnassignedCategory: false
    });
}


export class ContentItemSearchRequest implements IContentItemSearchRequest {
    searchText?: string | undefined;
    accountId?: string | undefined;
    platformId?: string | undefined;
    contentItemTypeId?: string | undefined;
    contentItemCategoryId?: string | undefined;
    includeDisabled?: boolean;
    isAllAccounts?: boolean | undefined;
    isUnassignedAccounts?: boolean;
    isUnassignedCategory?: boolean;
    dateAddedFrom?: Date | undefined;
    dateAddedTo?: Date | undefined;
    dateUpdatedFrom?: Date | undefined;
    dateUpdatedTo?: Date | undefined;

    constructor(data?: IContentItemSearchRequest) {
        if (data) {
            for (const property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchText = _data["searchText"];
            this.accountId = _data["accountId"];
            this.platformId = _data["platformId"];
            this.contentItemTypeId = _data["contentItemTypeId"];
            this.contentItemCategoryId = _data["contentItemCategoryId"];
            this.includeDisabled = _data["includeDisabled"];
            this.isAllAccounts = _data["isAllAccounts"];
            this.isUnassignedAccounts = _data["isUnassignedAccounts"];
            this.isUnassignedCategory = _data["isUnassignedCategory"];
            this.dateAddedFrom = _data["dateAddedFrom"] ? new Date(_data["dateAddedFrom"].toString()) : <any>undefined;
            this.dateAddedTo = _data["dateAddedTo"] ? new Date(_data["dateAddedTo"].toString()) : <any>undefined;
            this.dateUpdatedFrom = _data["dateUpdatedFrom"] ? new Date(_data["dateUpdatedFrom"].toString()) : <any>undefined;
            this.dateUpdatedTo = _data["dateUpdatedTo"] ? new Date(_data["dateUpdatedTo"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ContentItemSearchRequest {
        data = typeof data === 'object' ? data : {};
        const result = new ContentItemSearchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchText"] = this.searchText;
        data["accountId"] = this.accountId;
        data["platformId"] = this.platformId;
        data["contentItemTypeId"] = this.contentItemTypeId;
        data["contentItemCategoryId"] = this.contentItemCategoryId;
        data["includeDisabled"] = this.includeDisabled;
        data["isAllAccounts"] = this.isAllAccounts;
        data["isUnassignedAccounts"] = this.isUnassignedAccounts;
        data["isUnassignedCategory"] = this.isUnassignedCategory;
        data["dateAddedFrom"] = this.dateAddedFrom ? this.dateAddedFrom.toISOString() : <any>undefined;
        data["dateAddedTo"] = this.dateAddedTo ? this.dateAddedTo.toISOString() : <any>undefined;
        data["dateUpdatedFrom"] = this.dateUpdatedFrom ? this.dateUpdatedFrom.toISOString() : <any>undefined;
        data["dateUpdatedTo"] = this.dateUpdatedTo ? this.dateUpdatedTo.toISOString() : <any>undefined;
        return data;
    }
}

export interface IContentItemSearchRequest {
    searchText?: string | undefined;
    accountId?: string | undefined;
    platformId?: string | undefined;
    contentItemTypeId?: string | undefined;
    contentItemCategoryId?: string | undefined;
    includeDisabled?: boolean;
    isAllAccounts?: boolean | undefined;
    isUnassignedAccounts?: boolean;
    isUnassignedCategory?: boolean;
    dateAddedFrom?: Date | undefined;
    dateAddedTo?: Date | undefined;
    dateUpdatedFrom?: Date | undefined;
    dateUpdatedTo?: Date | undefined;
}